import { frontendURL } from '../../../helper/URLHelper';

const IaEntrevistaView = () => import('./IaEntrevistaView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ia-entrevista'),
    name: 'ia_entrevista_view',
    meta: {
      permissions: ['administrator'],
    },
    component: IaEntrevistaView,
  },
];
